export const Roles = Object.freeze({
  ROOT: 'root',
  ADMIN: 'admin',
  CARHOUSEADMIN: 'carHouseAdmin',
  USER: 'user',
});